import axios from "axios";
import { Dispatch } from "react";
import { transformShopifyCollectionsToCategories } from "../../clients/shopify/shopifyCollectionTransformer";
import { transformShopifyMenuToCategories } from "../../clients/shopify/shopifyMenuTransformer";
import { fetchCollectionProductCounts } from "../../clients/shopify/shopifyClient";
import { resetActiveSearchFlag } from "../reducers/itemReducer";

export const getCategoryTreeFromDB = () => async (dispatch: Dispatch<any>) => {
  try {
    // Check if we should use Shopify collections
    if (process.env.REACT_APP_USE_SHOPIFY_COLLECTIONS === 'true') {
      console.log('Using Shopify collections/menu for navigation');
      
      // First try to get categories from Shopify menu
      const menuCategoryTree = await transformShopifyMenuToCategories('main-menu');
      
      if (menuCategoryTree && menuCategoryTree.length > 0) {
        console.log('Successfully retrieved menu categories from Shopify');
        dispatch(categoryTreeData(menuCategoryTree));
      } else {
        // Fallback to collections if menu doesn't work
        console.log('Falling back to Shopify collections');
        const collectionCategoryTree = await transformShopifyCollectionsToCategories();
        dispatch(categoryTreeData(collectionCategoryTree));
      }
    } else {
      // Fallback to the original API endpoint
      console.log('Using backend API for menu categories');
      const res = await axios.get(process.env.REACT_APP_BACKEND_URL + `/category/tree`);
      dispatch(categoryTreeData(res.data));
    }
  } catch (err) {
    console.error('Error fetching category tree:', err);
    // In case of error, dispatch an empty category tree
    dispatch(categoryTreeData([]));
  }
};

const categoryTreeData = (data: CategoryTreeNode[]) => {
  return {
    type: "GET_TREE",
    categoryTree: data,
  };
};

export const saveNewCategoryFilterSelection = (
  selectedNode: CategoryTreeNode | null
) => {
  // Explicitly reset the active search flag to ensure category navigation works after search
  if (selectedNode) {
    console.log('Category selected, explicitly resetting active search flag');
    resetActiveSearchFlag();
  }
  
  return {
    type: "UPDATE_SELECTED_NODE",
    selectedNode,
  };
};

export const saveNewCategoryNavigationSelection = (
  selectedNode: CategoryTreeNode | null
) => {
  return {
    type: "UPDATE_NAVIGATION_NODE",
    selectedNode,
  };
};

// Enhanced category tree initialization that also fetches product counts
export const initializeCategoryTree = () => async (dispatch: Dispatch<any>) => {
  try {
    // First, fetch the collection product counts (this uses caching)
    // This will prime the cache or use existing cached data
    const productCounts = await fetchCollectionProductCounts();
    console.log('Loaded collection product counts:', productCounts);
    
    // Store product counts in the Redux store if needed
    dispatch({
      type: "SET_COLLECTION_PRODUCT_COUNTS",
      productCounts
    });
    
    // Then get the category tree as normal
    dispatch(getCategoryTreeFromDB());
  } catch (err) {
    console.error('Error initializing category tree:', err);
    // If there's an error fetching product counts, still try to get the category tree
    dispatch(getCategoryTreeFromDB());
  }
};
